module.exports = __webpack_public_path__ + "img/ba1a39b.jpg";